import { ITelemetrySendRPC } from "@prisma/studio-common";
import { check, getSignature } from "checkpoint-client";
import { IServerOptions } from "../StudioServer";
import getProjectHash from "../utils/getProjectHash";

export interface TelemetryChannelOptions {
  schemaPath: IServerOptions["schemaPath"];
  telemetry?: IServerOptions["telemetry"];
  versions?: IServerOptions["versions"];
}

export class TelemetryChannel {
  options: TelemetryChannelOptions;

  constructor(options: TelemetryChannelOptions) {
    this.options = {
      schemaPath: options.schemaPath,
      telemetry: options.telemetry ?? true,
      versions: options.versions,
    };

    // Ensure a signature exists
    getSignature().then(() => {
      // And send a `studio_launch` event
      this.send({
        command: "studio_launch",
        commandDetails: {},
        commandContext: "{}",
      });
    });
  }

  public respond = async (
    req: ITelemetrySendRPC["request"]
  ): Promise<ITelemetrySendRPC["response"]> => {
    const res: ITelemetrySendRPC["response"] = {
      requestId: req.requestId,
      channel: `-${req.channel}`,
      action: req.action,
      payload: {
        error: null,
        data: null,
      },
    };

    try {
      switch (req.action) {
        case "send":
          await this.send(req.payload.data);
          break;
      }
    } catch (e: any) {
      // Convert this Error object into a POJO so it can be transmitted
      res.payload.error = e.message;
    }

    return res;
  };

  private send = async ({
    command,
    commandDetails,
    commandContext,
  }: ITelemetrySendRPC["request"]["payload"]["data"]): Promise<void> => {
    if (!this.options.telemetry) {
      // Do not send telemetry if it is disabled
      return;
    }

    if (!this.options.versions) {
      // Insufficient context, bail
      return;
    }

    // TODO:: Need to start reporting `commandDetails` & `commandContext`
    check({
      product: "prisma-studio",
      command,
      version: this.options.versions.prisma,
      project_hash: getProjectHash(this.options.schemaPath),
    });
  };
}
